export const TYPE_OF_PAGES_MAP = {
  HOME_PAGE: 'homePage',
  SEARCH_PAGE: 'searchPage',
  DETAILS_PAGE: 'detailsPage'
};
